import { Quote, FlaskConical } from "lucide-react";

const MATTER_LABELS = {
  "lease-extension": "Lease extension (s.42)",
  "collective-enfranchisement": "Collective enfranchisement (s.13)",
  rtm: "Right to Manage (s.79)",
  "deed-of-variation": "Deed of variation",
  conveyancing: "Conveyancing",
  other: "Leasehold matter",
};

const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "LF";

export const resolveLogoUrl = (url) => (url && url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export function TestimonialCard({ t, compact = false }) {
  const logoSrc = resolveLogoUrl(t.firm_logo_url);
  return (
    <article
      className="card-soft rounded-2xl p-6 md:p-7 flex flex-col h-full relative overflow-hidden"
      data-testid={`testimonial-${t.id}`}
    >
      <Quote className="absolute -top-2 -right-1 w-20 h-20 text-white/[0.03]" strokeWidth={1} aria-hidden="true" />
      <div className="flex items-center justify-between gap-3 flex-wrap">
        {t.matter_type && (
          <span className="text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded" style={{ background: "rgba(0, 212, 170, 0.14)", color: "#00D4AA" }}>
            {MATTER_LABELS[t.matter_type] || t.matter_type}
          </span>
        )}
        {t.illustrative && (
          <span className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded bg-amber-500/10 text-amber-300 border border-amber-400/20" data-testid={`testimonial-illustrative-${t.id}`} title="Composite scenario based on typical leasehold workflows — not a named client">
            <FlaskConical className="w-3 h-3" /> Example scenario
          </span>
        )}
      </div>

      {!compact && t.headline && (
        <h3 className="mt-4 font-display text-lg md:text-xl text-white leading-snug">{t.headline}</h3>
      )}

      <blockquote className={`${compact ? "mt-4" : "mt-3"} text-slate-300 leading-relaxed text-[15px] flex-1`}>
        “{t.quote}”
      </blockquote>

      {(t.result_stat || t.result_label) && !compact && (
        <div className="mt-5 flex items-baseline gap-2 border-t border-white/5 pt-4">
          <span className="h-display text-3xl" style={{ color: "#00D4AA" }}>{t.result_stat}</span>
          <span className="text-xs text-slate-400">{t.result_label}</span>
        </div>
      )}

      <footer className="mt-5 flex items-center gap-3">
        {logoSrc ? (
          <img src={logoSrc} alt={t.firm_name || t.author_name} className="h-9 w-9 rounded-lg object-contain bg-white/90 p-1" data-testid={`testimonial-logo-${t.id}`} />
        ) : (
          <span className="h-9 w-9 rounded-lg flex items-center justify-center text-xs font-semibold text-white" style={{ background: "rgba(0, 212, 170, 0.2)", border: "1px solid rgba(0, 212, 170, 0.35)" }}>
            {initials(t.author_name)}
          </span>
        )}
        <div className="min-w-0">
          <p className="text-sm font-medium text-white truncate">{t.author_name}{t.author_role && t.author_role !== t.author_name ? <span className="text-slate-500"> · {t.author_role}</span> : null}</p>
          {t.firm_name && <p className="text-xs text-slate-400 leading-snug">{t.firm_name}</p>}
        </div>
      </footer>
    </article>
  );
}
